module.exports = __webpack_public_path__ + "static/img/365.2773172d.png";